import { HttpHandler } from 'msw'

import { createOrder } from './createOrder'
import { getAllOrders } from './getAllOrders'
import { getOrder } from './getOrder'

export const orders: HttpHandler[] = [createOrder, getAllOrders, getOrder]
